import axios from "axios";
import { drnEndpoint,  drnSearchFilterDropdown,  regionEndpoint, regionSearch } from '../endpoints';

// to get the primary category search function except the region search
export const fetchSearchResult2 = async (searchField: string, searchVal: string | number, offSet: number, token: any) => {
    try {
      const resp = await axios.get(`${drnEndpoint}?searchField=${searchField}&searchVal=${encodeURIComponent(searchVal)}&&offSet=${offSet}`, {
        method: 'get',
        headers: {
          'x-api-key':"gmedocumenthubtest.castrol.com",
          'Content-Type': 'application/json',
          Authorizationtoken: `Bearer ${token}`
        }
      });
      return resp.data;
    } catch (ex) {
      throw ex;
    }

    // try {
    // const res = await axios.get('http://localhost:3000/mock/drn_data_response.json');
    // return res.data;
    // }
    // catch(ex){
    //   throw ex;
    // } 
  };

  export const fetchSearchResult= async (
  searchField: string,
  searchVal: string | number,
  offSet: number,
  token: any
) => {
  try {
    const payload = {
      searchField,
      searchVal,
      offSet
    };

    const resp = await axios.post(
      drnEndpoint,
      payload,
      {
        headers: {
          "x-api-key": "gmedocumenthubtest.castrol.com",
          "Content-Type": "application/json",
          Authorizationtoken: `Bearer ${token}`
        }
      }
    );

    return resp.data;
  } catch (ex) {
    throw ex;
  }
};

  export const fetchFilterSearchResult = async (searchField: string, searchVal: string | number, offSet: number, filterParms: any, token: any) => {
    try {
      // const {document_type, country_name, invoice_number, nomination_number, port_name, region_name, delivery_date, cust_acct_name, vessel_name} = filterParms;
      const document_type = filterParms.document_type ? filterParms.document_type : null;
      const s_delivery_date = filterParms.s_delivery_date ? filterParms.s_delivery_date: null
      const e_delivery_date = filterParms.e_delivery_date ? filterParms.e_delivery_date: null
      const s_invoice_date = filterParms.s_invoice_date ? filterParms.s_invoice_date: null
      const e_invoice_date = filterParms.e_invoice_date ? filterParms.e_invoice_date: null

     const payload={  
        searchField: searchField,
        searchVal: searchVal,
        invoice_number :filterParms.invoice_number || [],
        nomination_number: filterParms.nomination_number || [],
        filter_order_number: filterParms.order_number || [],
        s_delivery_date: s_delivery_date,
        e_delivery_date: e_delivery_date,
        s_invoice_date: s_invoice_date,
        e_invoice_date: e_invoice_date,
        document_type: document_type,
        filter_cust_acct_name: filterParms.cust_acct_name || [],
        filter_cust_code: filterParms.cust_code || [],
        filter_region_name: filterParms.region_name || [],
        filter_country_name: filterParms.country_name || [],
        filter_port_name: filterParms.port_name || [],
        filter_vessel_name: filterParms.vessel_name || [],
        filter_vessel_imo_number: filterParms.vessel_imo_number || [],
        offSet: offSet
      }

      const resp = await axios.post(
        drnEndpoint,
        payload,
        {
          headers: {
            'x-api-key': "gmedocumenthubtest.castrol.com",
            'Content-Type': 'application/json',
            Authorizationtoken: `Bearer ${token}`
          }
        }
      );
      return resp.data;
    } catch (ex) {
      throw ex;
    }
    
    // const res = await axios.get('http://localhost:3000/mock/drn_data_response.json');
    // return res.data;
    // const result = await resp.json();
    
  };

 // to get the region drop down load data 
  export const fetchRegionSearchVals = async (token: any) => {
    try {
      const resp = await axios.get(`${regionEndpoint}`, {
        method: 'get',
        headers: {
          'x-api-key':"gmedocumenthubtest.castrol.com",
          'Content-Type': 'application/json',

          Authorizationtoken: `Bearer ${token}`
        }
      });
      // const resp = await axios.get('http://localhost:3000/mock/region_res.json');
      return resp.data;
    }
    catch (ex) {
      throw ex;
    }

  }




 // to get the primary category region search 
  export const fetchRegionSearchResult = async (searchField: string, region: string[], country: string[], port: string[], offSet: number, token: any) => {
    try {
// const regionParams = region.length > 0 ? region.map(r => `region_name=${encodeURIComponent(r)}`).join("&") : "region_name=null";
// const countryParams = country.length > 0 ? country.map(c => `country_name=${encodeURIComponent(c)}`).join("&") : "country_name=null";
// const portParams = port.length > 0 ? port.map(p => `port_name=${encodeURIComponent(p)}`).join("&") : "port_name=null";

// const resp = await axios.get(`${regionSearch}?${regionParams}&${countryParams}&${portParams}&offSet=${offSet}`, {
//         method: 'get',
//         headers: {
//           'x-api-key':"gmedocumenthubtest.castrol.com",
//           'Content-Type': 'application/json',
//           Authorizationtoken: `Bearer ${token}`
//         }
//       });
//       return resp.data;
//     } catch (ex) {
//       throw ex;
//     }
const payload={
  region_name: region.length > 0 ? region : [],
  country_name: country.length > 0 ? country : [],
  port_name: port.length > 0 ? port : [],
  
  offSet: offSet
}
      const resp = await axios.post(
        regionSearch,
        payload,
        {
          headers: {
            'x-api-key': "gmedocumenthubtest.castrol.com",
            'Content-Type': 'application/json',
            Authorizationtoken: `Bearer ${token}`
          }
        }
      );
      return resp.data;
    } catch (ex) {
      throw ex;
    }
  };

  export const fetchFilterRegionSearchResult = async (searchField: string, region: string[], country: string[], port: string[], offSet: number, filterParms: any, token: any) => {
    try {
      const document_type = filterParms.document_type ? filterParms.document_type : null;
      const s_delivery_date = filterParms.s_delivery_date ? filterParms.s_delivery_date: null
      const e_delivery_date = filterParms.e_delivery_date ? filterParms.e_delivery_date: null
      const s_invoice_date = filterParms.s_invoice_date ? filterParms.s_invoice_date: null
      const e_invoice_date = filterParms.e_invoice_date ? filterParms.e_invoice_date: null
     
     
      const payload={
        region_name: region.length > 0 ? region : [],
        country_name: country.length > 0 ? country : [],
        port_name: port.length > 0 ? port : [],
        filter_region_name: filterParms.region_name || [],
        filter_country_name: filterParms.country_name || [],
        filter_port_name: filterParms.port_name || [],
        filter_vessel_name: filterParms.vessel_name || [],
        filter_vessel_imo_number: filterParms.vessel_imo_number || [],
        filter_cust_acct_name: filterParms.cust_acct_name || [],
        filter_cust_code: filterParms.cust_code || [],
        invoice_number:filterParms.invoice_number || [],
        nomination_number : filterParms.nomination_number || [],
        filter_order_number : filterParms.order_number || [],
        s_delivery_date: s_delivery_date,
        e_delivery_date: e_delivery_date,
        s_invoice_date: s_invoice_date,
        e_invoice_date: e_invoice_date,
        document_type: document_type,
        offSet: offSet
      }


      console.log("payload", payload);
      const resp = await axios.post(
        regionSearch,
        payload,
        {
          headers: {
            'x-api-key': "gmedocumenthubtest.castrol.com",
            'Content-Type': 'application/json',
            Authorizationtoken: `Bearer ${token}`
          }
        }
      );
      return resp.data;
    } catch (ex) {
      throw ex;
    }
  };

  //get -search-filter dropdown -based on primary search (if needed kust remove 1 and use it)
  export const fetchDropdownData1 = async (
  payload: any,
  token: any
) => {
  
  const resp = await axios.post(
    drnSearchFilterDropdown,
    payload,
    {
      headers: {
        "x-api-key": "gmedocumenthubtest.castrol.com",
        "Content-Type": "application/json",
        Authorizationtoken: `Bearer ${token}`
      }
    }
  );

  return resp.data;
};
  //get -search-filter dropdown -based on nested  filter (it will show only the available values based on the primary search and other filter values)

export const fetchDropdownData = async (
  payload: any,
  token: any
) => {

  const requestPayload = {
    ...payload,

    // convert filter params to backend format
    filter_region_name: payload.region_name || [],
    filter_country_name: payload.country_name || [],
    filter_port_name: payload.port_name || [],
    filter_vessel_name: payload.vessel_name || [],
    filter_vessel_imo_number: payload.vessel_imo_number || [],
    filter_cust_acct_name: payload.cust_acct_name || [],
    filter_cust_code: payload.cust_code || [],
     filter_order_number: payload.order_number || [],
  };

  console.log(
    "Dropdown Request Payload:",
    JSON.stringify(requestPayload, null, 2)
  );

  const resp = await axios.post(
    drnSearchFilterDropdown,
    requestPayload,
    {
      headers: {
        "x-api-key": "gmedocumenthubtest.castrol.com",
        "Content-Type": "application/json",
        Authorizationtoken: `Bearer ${token}`,
      },
    }
  );

  return resp.data;
};